// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bz-b";
export var colorBlue = "_bz-8";
export var colorDot = "_bz-0";
export var colorDotLarge = "_bz-2";
export var colorDotSmall = "_bz-1";
export var colorGreen = "_bz-7";
export var colorGrey = "_bz-3";
export var colorOrange = "_bz-5";
export var colorPink = "_bz-a";
export var colorPurple = "_bz-9";
export var colorRed = "_bz-4";
export var colorYellow = "_bz-6";